<button
  type="button"
  class="header-bar-trigger-button header-bar-help-trigger"
  [attr.aria-label]="TranslationKeys.HeaderBarKnowledgeBase | translate"
  (click)="openKnowledgeBase()"
>
  <i [nimbusIcon]="ICONS.QUESTION"></i>
</button>
